// https://docs.google.com/spreadsheets/d/16MWXF7SAbQh9xXZ49M_OIRDLXJWcrEyOtJP_rzl-tRY/edit#gid=236970639

import { companyFinancialsWithout } from './newCalculator/companyFinancialsWithout'
import { companyFinancialsWithExtraMarketing } from './newCalculator/companyFinancialsWithExtraMarketing'
import { companyFinancialsWithoutExtraMarketing } from './newCalculator/companyFinancialsWithoutExtraMarketing'

const newCalculator = (inputs = {}, months = 36) => {
  const {
    mrr = 100000, // C11
    mom = 0.04, // C5
    me = 250000,
    gm = 0.85,
    cb = 400000
  } = inputs

  const arr = mrr * 12 // C3
  const yoy = Math.pow(1 + mom, 12) - 1 // C4
  const gross_margin = gm // C6
  const monthly_expenses = me // C10
  const wacc = 0 // C12
  const bank_account_at_start = cb // C13
  const expenses_per_revenu = 0.8 // C14
  const sales_marketing_costs_share = 0.4 // C15
  const total_expenses = expenses_per_revenu * mom // C16

  const share_of_arr_fejron = 0.5 // C18
  const investor_irr_requirement = 0.1002 // C19
  const irr_equivalent_monthly_interest_rate =
    Math.pow(1 + investor_irr_requirement, 1 / 12) - 1 // C20

  const efficiency = 0.67 // C23
  const increased_MRR_per_unit_spent_SM =
    (mom / sales_marketing_costs_share) * efficiency // C24
  const increased_ARR_per_unit_spent_SM =
    (yoy / sales_marketing_costs_share) * efficiency // C25

  const fejron_increased_spend_marketing = 1 // C28

  // Equity funding
  const month_runway_runout = 21 // C32
  const original_number_of_shares = 1000000 // C33
  const saas_multiple = 10 // C34

  const variables = {
    mrr, // C11
    arr, // C3
    yoy, // C4
    mom, // C5
    gross_margin, // C6
    monthly_expenses, // C10
    wacc, // C12
    bank_account_at_start, // C13
    expenses_per_revenu, // C14
    sales_marketing_costs_share, // C15
    total_expenses, // C16
    share_of_arr_fejron, // C18
    investor_irr_requirement, // C19
    irr_equivalent_monthly_interest_rate, // C20
    efficiency, // C23
    increased_MRR_per_unit_spent_SM, // C24
    increased_ARR_per_unit_spent_SM, // C25
    fejron_increased_spend_marketing, // C28
    // Equity funding
    month_runway_runout, // C32
    original_number_of_shares, // C33
    saas_multiple // C34
  }
  // console.log('variables', variables)
  return {
    companyFinancialsWithoutFejron: companyFinancialsWithout(variables, months),
    companyFinancialsWithFejronExtraMarketing:
      companyFinancialsWithExtraMarketing(variables, months),
    companyFinancialsWithoutExtraMarketing:
      companyFinancialsWithoutExtraMarketing(variables, months),
    variables
  }
}

export { newCalculator }
